



































































import { Component, Vue } from 'vue-property-decorator';

@Component({
  props: ['privateNetwork'],
})
export default class PrivateNetworkConnectedMachines extends Vue {
  workspaceId = 0;
  regionId = 0;
  mounted() {
    this.workspaceId = parseInt(this.$route.params.workspaceId, 10);
    this.regionId = parseInt(this.$route.params.regionId, 10);
  }
}
